// 1️⃣ Changed from App to Root
import { createBrowserRouter, Navigate, Route, RouterProvider, Routes } from 'react-router-dom';

import ErrorPage from './components/ErrorPage.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import AccountDetailsChildForm from './pages/dashboard/components/AccountDetailsChild.jsx';
import DashboardLayout from './pages/dashboard/index.jsx';
import AccountDetails from './pages/dashboard/pages/AccountDetails.jsx';
import Coupons from './pages/dashboard/pages/Coupons.jsx';
import CreditBalance from './pages/dashboard/pages/CreditBalance.jsx';
import DashboardHome from './pages/dashboard/pages/DashboardHome.jsx';
import Membership from './pages/dashboard/pages/Membership.jsx';
import Orders from './pages/dashboard/pages/Orders.jsx';
import Points from './pages/dashboard/pages/Points.jsx';
import Vouchers from './pages/dashboard/pages/Vouchers.jsx';
import IndexPage from './pages/IndexPage.jsx';
import OutletLayoutPage from './pages/layout/OutletLayout.jsx';
import PageLayoutLocation from './pages/layout/PageLayoutLocation.jsx';
import Checkout from './pages/membership/Checkout/checkout.jsx';
import OrderConfirmation from './pages/membership/orderConfirmation.jsx';
import AuthForgotPassword from './pages/membership/signIn/AuthForgotPassword.jsx';
import AuthSetPassword from './pages/membership/signIn/AuthSetPassword.jsx';
import AuthLogin from './pages/membership/signIn/AuthSignIn.jsx';
import AuthVerifyOTP from './pages/membership/signIn/AuthVerifyOTP.jsx';
import SignIn from './pages/membership/signIn/index.jsx';
import UserRegister from './pages/membership/signIn/Register.jsx';
import OnlineSalesLayoutPage from './pages/onlineSales/layout.jsx';
import AddOnPage from './pages/onlineSales/pages/addOns/index.jsx';
import CheckoutPage from './pages/onlineSales/pages/checkout/index.jsx';
import HomePage from './pages/onlineSales/pages/home/index.jsx';
import PrivacyPolicyPage from './pages/onlineSales/pages/privacyPolicy/index.jsx';
import ProductsPage from './pages/onlineSales/pages/products/index.jsx';
import ProductDetailPage from './pages/onlineSales/pages/products/ProductDetailPage.jsx';
import Successed from './pages/status/Successed.jsx';
import FormAgreement from './pages/waiver/FormAgreement.jsx';
import FormChildren from './pages/waiver/FormChildren.jsx';
import FormEmailCheck from './pages/waiver/FormEmailCheck.jsx';
import FormEmailPassword from './pages/waiver/FormEmailPassword.jsx';
import FormForgotPassword from './pages/waiver/FormForgotPassword.jsx';
import FormUser from './pages/waiver/FormUser.jsx';
import FormWaiver from './pages/waiver/FormWaiver.jsx';
import FormWaiverChilds from './pages/waiver/FormWaiverChilds.jsx';
import FormWaiverSign from './pages/waiver/FormWaiverSign.jsx';

function Root() {
    return (
        // <Suspense fallback={<PageLoader />}>
        <Routes>
            <Route index element={<IndexPage />}></Route>
            <Route path='privacy-policy' element={<PrivacyPolicyPage />} />

            <Route path=':brandId' element={<PageLayoutLocation />}>
                <Route path=':outletId' element={<OutletLayoutPage />}>
                    <Route index element={<Navigate to='online-sales/home' />} />

                    <Route path='online-sales' element={<OnlineSalesLayoutPage />}>
                        <Route index element={<Navigate to='home' />} />

                        <Route path='home' element={<HomePage />} />
                        <Route path=':productId' element={<ProductsPage />} />
                        <Route path=':productId/:id' element={<ProductDetailPage />} />
                        <Route path='checkout' element={<CheckoutPage />} />
                        <Route path='add-ons' element={<AddOnPage />} />
                    </Route>

                    <Route path='check-email' element={<FormEmailCheck />} />
                    <Route path='register-email' element={<FormEmailPassword />} />
                    <Route path='forgot-password' element={<FormForgotPassword />} />

                    <Route path='waiver'>
                        <Route path='' element={<FormWaiver />} />
                        <Route path='user' element={<FormUser />} />
                        <Route path='add-children' element={<FormChildren />} />
                        <Route path='children' element={<FormWaiverChilds />} />
                        <Route path='sign' element={<FormWaiverSign />} />
                        <Route path='agreement' element={<FormAgreement />} />
                    </Route>

                    <Route path='membership'>
                        <Route path='' element={<SignIn />} />
                        <Route path='login' element={<AuthLogin />} />
                        <Route path='register' element={<UserRegister />} />
                        <Route path='verify' element={<AuthVerifyOTP />} />
                        <Route path='password' element={<AuthSetPassword />} />
                        <Route path='order' element={<OrderConfirmation />} />
                        <Route path='forgot' element={<AuthForgotPassword />} />
                        <Route path='checkout' element={<Checkout />} />
                    </Route>

                    <Route
                        path='dashboard'
                        element={
                            <ProtectedRoute>
                                <DashboardLayout />
                            </ProtectedRoute>
                        }>
                        <Route index element={<DashboardHome />} />
                        <Route path='membership' element={<Membership />} />
                        <Route path='account-details' element={<AccountDetails />} />
                        <Route path='account-details/edit-child' element={<AccountDetailsChildForm />} />
                        <Route path='credit-balance' element={<CreditBalance />} />
                        <Route path='points' element={<Points />} />
                        <Route path='vouchers' element={<Vouchers />} />
                        <Route path='coupons' element={<Coupons />} />
                        <Route path='orders' element={<Orders />} />
                    </Route>
                </Route>
            </Route>

            <Route path='check-payment' element={<Successed />} />
        </Routes>
        // </Suspense>
    );
}

const router = createBrowserRouter([{ path: '*', element: <Root />, errorElement: <ErrorPage /> }]);

export default function App() {
    return <RouterProvider router={router} />;
}

/* New Route for

OTP and Password = 
/register-email

Agreemenr Waiver =
waiver/agreement

Parent Form =
waiver/user

Children Form = 
waiver/add-children

Forgot Password = 
/forgot-password




*/
